import { gql, TypedDocumentNode } from '@apollo/client'

import { ERROR_FRAGMENT } from 'providers/graphql'
import { Data, Variables } from './types'

export const UPDATE_PAGE: TypedDocumentNode<Data, { input: Variables }> = gql`
  ${ERROR_FRAGMENT}

  mutation updatePage($input: UpdatePageInput!) {
    updatePage(input: $input) {
      errors {
        ...ErrorFragment
      }
    }
  }
`
